var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.063C30 10.731 28.6455 12.084 27 12.084C25.3545 12.084 24 10.731 24 9.063V3.021C24 1.3515 25.3545 0 27 0C28.6455 0 30 1.3515 30 3.021V9.063Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7699 54.0001C13.4339 54.0001 13.0919 53.9221 12.7709 53.7616C11.6669 53.2006 11.2184 51.8416 11.7704 50.7211L25.1804 23.5306C25.5584 22.7626 26.3324 22.2781 27.1799 22.2781C28.0274 22.2781 28.8014 22.7626 29.1794 23.5306L42.5909 50.7211C43.1429 51.8416 42.6959 53.2006 41.5919 53.7616C40.4879 54.3196 39.1454 53.8666 38.5934 52.7476L27.1814 29.6101L15.7709 52.7476C15.3779 53.5411 14.5889 54.0001 13.7699 54.0001Z",
    fill: "#FFAC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1815 30.5879C26.787 30.5879 26.4075 30.4289 26.1285 30.1454L5.26804 8.99686C4.68604 8.40586 4.68604 7.45036 5.26804 6.86086C5.85004 6.27136 6.79354 6.27136 7.37404 6.86086L27.1815 26.9399L46.986 6.85936C47.5695 6.26986 48.5115 6.26986 49.0935 6.85936C49.6755 7.45036 49.6755 8.40586 49.0935 8.99536L28.236 30.1454C27.9555 30.4274 27.5775 30.5879 27.1815 30.5879Z",
    fill: "#58595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0223 29.0775C51.0223 42.4245 40.3498 53.244 27.1813 53.244C14.0158 53.244 3.3418 42.4245 3.3418 29.0775C3.3418 15.7275 14.0158 4.90796 27.1813 4.90796C40.3483 4.90646 51.0223 15.7275 51.0223 29.0775Z",
    fill: "#DD2E44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0617 29.0776C45.0617 39.0886 37.0592 47.2036 27.1817 47.2036C17.3072 47.2036 9.30322 39.0886 9.30322 29.0776C9.30322 19.0651 17.3072 10.9501 27.1817 10.9501C37.0592 10.9486 45.0617 19.0651 45.0617 29.0776Z",
    fill: "#E6E7E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.06 1.88538C42.591 1.88538 40.3575 2.89938 38.739 4.54038L51.3825 17.3564C52.9995 15.7169 54 13.4519 54 10.9484C54 5.94438 49.9965 1.88538 45.06 1.88538ZM8.94 1.88538C11.4075 1.88538 13.6425 2.89938 15.261 4.54038L2.6175 17.3564C1.0005 15.7169 0 13.4519 0 10.9484C0 5.94438 4.002 1.88538 8.94 1.88538Z",
    fill: "#FFCC4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30H27C26.172 30 25.5 29.3295 25.5 28.5V15C25.5 14.172 26.172 13.5 27 13.5C27.828 13.5 28.5 14.172 28.5 15V27H34.5C35.3295 27 36 27.672 36 28.5C36 29.3295 35.3295 30 34.5 30Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/emoji-3.07bbc79ef527ad0e5911ed2315f78923.svg";
export { ForwardRef as ReactComponent };